import React from 'react'
import { PongSpinner } from 'react-spinners-kit'
import { useStyles } from './Styles'
import Logo from '../Logo'

export const FullBodyWithLogoLoader = ({ loading }) => {
  let classes = useStyles()
  return (
    <div className={classes.fullBodyLoaderWrapper + ' '+ classes.FullBodyWithLogoLoaderWrapper}>
      <Logo/>
      <PongSpinner
        size={80}
        color='#427cac'
        loading={loading}
      />
    </div>
  )
}
